export const _ADD               = "7wf+YzPNzZVv5AxC2lAaJA==";
export const _EDIT              = "9Ulp/TGSIWifU8dqzFnFwQ==";
export const _VIEW              = "qewesLAo8gcL3teUgttuYw==";
export const _DELETE            = "u9zerxVw5217vIMC8BwrVQ==";
export const _RECOVER           = "z8TFnOiAP20VmZ7CFE224A==";
export const _LIST              = "hOaA7sLrECOCEQqCNmZWuA==";
export const _TRASH             = "WUOHnhecSiqzo9vaE0WSyA==";